<template>
<label
  class="preview-image-input"
  :class="{ 'preview-image-input_error': error }"
>
  <div v-if="!currentPreview" class="preview-image-input__empty">
    <img
      class="preview-image-input__icon"
      src="../assets/download_icon.svg"
    >
    <p
      class="preview-image-input__deskr"
    >
      добавить фото
    </p>
  </div>
  <div v-else class="preview-image-input__preview">
    <img class="preview-image-input__preview-image" :src="currentPreview">
    <img class="preview-image-input__cross" src="../assets/cross_white_icon.svg">
  </div>
  <input class="preview-image-input__input" type="file" accept="image/*" @change="handleFileLoad">
</label>
</template>

<script>
export default {
  name: 'PreviewImageInput',
  props: {
    value: {
      required: true
    },
    error: {
      required: false,
      type: Boolean,
      default: false
    },
    providedPreview: {
      required: false,
      type: String,
      default: ''
    }
  },
  data() {
    return {
      innerPreview: ''
    }
  },
  computed: {
    currentPreview() {
      return this.innerPreview != '' ? this.innerPreview : this.providedPreview
    }
  },
  methods: {
    handleFileLoad(e) {
      if (e.target.files[0]) {
        this.$emit('input', e.target.files[0])
        let reader = new FileReader()
        reader.onload = () => this.innerPreview = reader.result
        reader.readAsDataURL(e.target.files[0])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/colors";

.preview-image-input {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: colors.$gray8b;
  cursor: pointer;
  &:hover &__preview-image {
    filter: brightness(40%);
  }
  &:hover &__cross {
    opacity: 1;
  }
  &__empty, &__preview {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: colors.$grayef;
  }
  &_loaded {
    background-color: #fff;
    border: 1px solid #000;
  }
  &_error {
    background-color: #fff;
    border: 1px solid colors.$redff;
  }
  &__icon {
    position: absolute;
    top: calc(50% - 12px);
    left: calc(50% - 12px);
    width: 24px;
    &_hidden {
      display: none;
    }
  }
  &__input {
    display: none;
  }
  &__deskr {
    width: 65%;
    position: absolute;
    top: 60%;
    left: 17.5%;
    font-size: 10px;
    text-align: center;
  }
  &__preview-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 200ms filter ease;
  }
  &__cross {
    width: 15px;
    opacity: 0;
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
    transition: 200ms all ease;
  }
}
</style>